import { useTranslation } from 'react-i18next'

export default function QuietHourCard({ quietHour, onEdit, onDelete, onToggle }) {
  const { t } = useTranslation('settings')
  const { id, name, start, end, days, enabled } = quietHour

  // Get day names from translations (array)
  const dayNames = t('quietHours.days.short', { returnObjects: true })

  return (
    <div className={`p-4 border rounded-lg transition-all ${
      enabled
        ? 'border-gray-200 bg-white hover:border-gray-300'
        : 'border-gray-200 bg-gray-50 opacity-60'
    }`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {/* Toggle */}
          <button
            onClick={() => onToggle(id)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
              enabled ? 'bg-primary-600' : 'bg-gray-300'
            }`}
            aria-label={enabled ? t('quietHours.card.toggle.disable') : t('quietHours.card.toggle.enable')}
          >
            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              enabled ? 'translate-x-6' : 'translate-x-1'
            }`} />
          </button>

          {/* Info */}
          <div>
            <h4 className={`text-sm font-medium ${enabled ? 'text-gray-900' : 'text-gray-500 line-through'}`}>
              {name || t('quietHours.card.defaultName')}
            </h4>
            <p className="text-sm text-gray-600">
              {start} - {end}
            </p>
            <div className="flex gap-1 mt-1">
              {days.sort((a, b) => a - b).map(d => (
                <span key={d} className="px-1.5 py-0.5 text-xs font-medium bg-gray-100 text-gray-700 rounded">
                  {dayNames[d]}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onEdit(quietHour)}
            className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg"
            aria-label={t('quietHours.card.edit')}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={() => onDelete(id)}
            className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg"
            aria-label={t('quietHours.card.delete')}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
